import { tableFilterApi } from 'modules/tableFilter';
import { exportClosedLostReport } from './exportClosedLostReport';

export * from './closedLostReport';
export * from './exportClosedLostReport';

export const closedLostReportApi = {
  ...tableFilterApi,
  exportClosedLostReport,
};
